import { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import CarCard from './CarCard';
import '../AllCss/UpcomingCarsCarousel.css';

function UpcomingCarsCarousel({ cars }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  
  // Dynamically adjust cards per view based on available cars
  const cardsPerView = Math.min(3, cars.length);
  const totalSlides = Math.max(1, cars.length - cardsPerView + 1);

  // Auto-slide every 5 seconds (only if there are multiple slides)
  useEffect(() => {
    if (isPaused || totalSlides <= 1 || cars.length <= cardsPerView) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, 5000);

    return () => clearInterval(interval);
  }, [isPaused, totalSlides, cars.length, cardsPerView]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  if (!cars || cars.length === 0) {
    return null;
  }

  return (
    <div 
      className="upcoming-carousel"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="carousel-header">
        <div className="carousel-title-section">
          <h2 className="carousel-title">Upcoming cars</h2>
        </div>
        <div className="carousel-controls">
            <button 
            className="carousel-arrow carousel-arrow-left" 
              onClick={prevSlide}
            disabled={totalSlides <= 1}
            aria-label="Previous"
            >
            <ChevronLeft size={24} />
            </button>
            <button 
            className="carousel-arrow carousel-arrow-right" 
              onClick={nextSlide}
            disabled={totalSlides <= 1}
            aria-label="Next"
            >
            <ChevronRight size={24} />
            </button>
          </div>
      </div>

      <div className="carousel-container">
          <div 
          className="carousel-track"
            style={{
              transform: `translateX(-${currentIndex * (100 / cardsPerView)}%)`,
            }}
          >
          {cars.map((car) => {
            // Add expected launch date to car object for badge display
                      const launchDate = new Date(car.createdAt);
                      launchDate.setDate(launchDate.getDate() + 3);
            const carWithBadge = {
              ...car,
              expectedLaunchDate: launchDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).toUpperCase()
            };
            
            return (
              <div key={car.id} className="carousel-slide">
                <CarCard car={carWithBadge} isUpcoming={true} />
                  </div>
            );
          })}
        </div>
      </div>

      {/* Indicators */}
      {totalSlides > 1 && (
        <div className="carousel-indicators">
          {Array.from({ length: totalSlides }).map((_, index) => (
            <button
              key={index}
              className={`carousel-indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default UpcomingCarsCarousel;

